import React, { Fragment, useState, useEffect } from "react";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import GetAdminService from "../../../services/admin/GetAdminService";
import { useHistory } from "react-router";
import CustomPagination from "../../pagination/Pagination";
import CustomLoader from "../../customLoader/CustomLoader";
import Loader from "react-loader-spinner";
import "./StudentProgress.css";
import swal from "sweetalert";
const Goals = () => {
  const [goalPageData, setGoalPageData] = useState();
  const [page, setPage] = useState(1);
  const [user] = useState(localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")));
  const [deleteGoalId, setDeleteGoalId] = useState();
  const [loading, setLoading] = useState(false);
  const [publishedLoading, setPublishedLoading] = useState(false);
  const [publishedButtonIndex, setPublishedButtonIndex] = useState(-1);
  const [, setUncheck] = useState([]);
  const [goalData, setGoalData] = useState();
  let history = useHistory();
  const getGoalPageData = () => {
    setLoading(true);
    let obj = {
      page: page,
      role: "admin"
    };
    GetAdminService.goalAdminPage(obj).then(data => {
      setGoalPageData(data?.data);
      setGoalData(data?.data);
      let convertedData = DataMapping(data?.data?.result);
      if (convertedData.length > 0) {
        setConvertedDataToGoalpageData(convertedData);
      }
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  };
  const duplicateGoal = value => {
    let obj = {
      goal_id: value?.id
    };
    GetAdminService.duplicateAdminGoal(obj).then(() => {
      getGoalPageData();
    }).catch(() => {});
  };
  const deleteGoalRequirement = value => {
    const goalId = value?.id;
    setDeleteGoalId(goalId);
    let obj = {
      goal_id: goalId
    };
    GetStudentService.deleteGoalRequirement(obj).then(async () => {
      const confirmed = await swal({
        title: "Delete?",
        text: "Are you sure you want to delete?",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          confirm: "OK"
        },
        dangerMode: true,
        closeOnClickOutside: false
      });
      if (confirmed) {
        deleteGoalAfterRequirement(goalId);
      }
    }).catch(() => {});
  };
  const deleteGoalAfterRequirement = (goalId = deleteGoalId) => {
    let obj = {
      deleted: true
    };
    GetStudentService.deleteGoal(obj).then(() => {
      goalDeleteConfirmation(goalId);
    }).catch(() => {});
  };
  const goalDeleteConfirmation = value => {
    let obj = {
      delete_goal_id: value
    };
    GetStudentService.deleteGoalConfirmation(obj).then(() => {
      setDeleteGoalId();
      getGoalPageData();
    }).catch(() => {});
  };
  const DataMapping = value => {
    for (let i = 0; i < value.length; i++) {
      for (let j = 0; j < value[i].publish_data.length; j++) {
        if (value[i].publish_data[j].school_id == user?.school_id) {
          value[i].published = value[i].publish_data[j].published;
          value[i].data = value[i].publish_data[j].data_mapped_percentage;
        }
        if (value[i].publish_data[j].default_goal === true) {
          value[i].default_goal = value[i].publish_data[j].default_goal;
        }
      }
      if (value[i].published == "" && value[i].data == "") {
        for (let j = 0; j < value[i].publish_data.length; j++) {
          if (value[i].publish_data[j].school_id == null) {
            value[i].published = value[i].publish_data[j].published;
            value[i].data = value[i].publish_data[j].data_mapped_percentage;
          }
        }
      }
    }
    return value;
  };
  const publishOrUnPublishGoal = (item, index, publishValue) => {
    setPublishedLoading(true);
    setPublishedButtonIndex(index);
    let obj = {
      goal_id: item?.id,
      inter_published: publishValue
    };
    GetAdminService.goalPublished(obj).then(() => {
      setPublishedLoading(false);
      getGoalPageData();
    }).catch(() => {
      setPublishedLoading(false);
    });
  };
  const setConvertedDataToGoalpageData = data => {
    if (data) {
      setGoalPageData({
        ...goalPageData,
        result: data
      });
      let unchecked = data?.filter(item => item.published === false).map(item => item?.id);
      setUncheck(unchecked);
    }
  };
  const openGoalView = value => {
    history.push(`/admin/goal/${value?.id}`);
  };
  const openGoalView1 = () => {
    swal({
      text: `Conceal Goal cannot be edited. Kindly Broadcast the Goal to edit.`,
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: true
      },
      closeOnClickOutside: false
    });
    setPublishedLoading(false);
  };
  const undoGoalDelete = value => {
    let obj = {
      goal_id: value?.id,
      deleted: "True"
    };
    GetStudentService.undoGoalDelete(obj).then(() => {
      getGoalPageData();
    }).catch(() => {});
  };
  useEffect(() => {
    getGoalPageData();
  }, [page]);
  const renderPublishSpinner = index => publishedButtonIndex === index && publishedLoading ? <Loader type="TailSpin" color="white" height={16} width={16} /> : null;
  return <Fragment>
      <div className="admin-ccplus-panel-header">
        <div>
          <h2 className="admin-ccplus-panel-title">Goals</h2>
          <p className="admin-ccplus-panel-hint">
            Create, broadcast, and manage student goals
          </p>
        </div>
        <button onClick={() => history.push("/admin/goal")} className="admin-ccplus-btn primary toolbar">
          
          New Goals
        </button>
      </div>

      {loading ? <div className="admin-ccplus-list-loading">
          <CustomLoader variant="inline" color="#007bff" size={42} />
        </div> : <div className="admin-ccplus-list">
          {goalPageData?.result?.length > 0 ? goalPageData.result.map((item, index) => <div key={item?.id || index} className={`admin-ccplus-item ${item?.deleted ? "is-deleted" : ""}`}>
          
                <div className="admin-ccplus-item-main">
                  <p className="admin-ccplus-item-name">{item?.goal_name}</p>
                  <div className="admin-ccplus-item-meta">
                    {item?.deleted ? <span className="admin-ccplus-badge deleted">Deleted</span> : item?.inter_published ? <span className="admin-ccplus-badge broadcast">Broadcasted</span> : <span className="admin-ccplus-badge conceal">Concealed</span>}
              
                  </div>
                </div>

                <div className="admin-ccplus-item-actions">
                  {item.inter_published && item.deleted === false ? <button onClick={() => publishOrUnPublishGoal(item, index, "False")} className="admin-ccplus-btn conceal">
              
                      Conceal Goal
                      {renderPublishSpinner(index)}
                    </button> : !item?.inter_published && item.deleted === false ? <button className="admin-ccplus-btn broadcast" onClick={() => publishOrUnPublishGoal(item, index, "True")}>
              
                      Broadcast Goal
                      {renderPublishSpinner(index)}
                    </button> : null}

                  {item.deleted === false && <button className="admin-ccplus-btn primary" onClick={() => duplicateGoal(item)}>
              
                      Duplicate
                    </button>}
            

                  {item?.is_global === true && item?.deleted === false && item?.inter_published === false ? <button onClick={() => openGoalView(item)} className="admin-ccplus-btn secondary">
              
                      Edit
                    </button> : <button onClick={() => openGoalView1()} className="admin-ccplus-btn secondary">
              
                      Edit
                    </button>}
            

                  {item.deleted === false && <button className="admin-ccplus-btn primary" onClick={() => deleteGoalRequirement(item)}>
              
                      Delete
                    </button>}
            

                  {item?.deleted && <button onClick={() => undoGoalDelete(item)} className="admin-ccplus-btn danger">
              
                      Undo
                    </button>}
            
                </div>
              </div>) : <p className="admin-ccplus-empty">No goals found</p>}
        
        </div>}
      

      <div className="admin-ccplus-pagination">
        <CustomPagination count={goalData} pageValue={page} setPage={setPage} />
      </div>
    </Fragment>;
};
export default Goals;